import { render, staticRenderFns } from "./salesteamlead_dashboard.vue?vue&type=template&id=96e8e7de&scoped=true&"
import script from "./salesteamlead_dashboard.vue?vue&type=script&lang=js&"
export * from "./salesteamlead_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead_dashboard.vue?vue&type=style&index=0&id=96e8e7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8e7de",
  null
  
)

export default component.exports